import ICustomer from "@/types/customer";
import { IStateCustomer } from "@/apps/merchant3/models/IStateCustomer";
import { IOptionDropdown } from "@/types/dropdown";
import { EContract } from "@/apps/merchant3/models/IStateContract";

const mutations = {
  SET_CUSTOMER: (state: IStateCustomer, payload: ICustomer): void => {
    Object.keys(payload).forEach((key) => {
      state[key] = payload[key];
    });
  },
  RESET_CUSTOMER: (state: { customer: { test: string } }): void => {
    Object.keys(state).forEach((key) => (state[key] = null));
  },
  SET_IS_FRAUD: (state: IStateCustomer, payload: EContract): void => {
    state.isFraud = payload;
  },
  SET_CUSTOMER_STATE: (
    state: IStateCustomer,
    payload: IOptionDropdown
  ): void => {
    state.state = payload.name;
    state.stateCode = payload.code;
  },
  SET_CUSTOMER_CITY: (
    state: IStateCustomer,
    payload: IOptionDropdown
  ): void => {
    state.city = payload.name;
  },
  RESET_CUSTOMER_CITY: (state: IStateCustomer): void => {
    state.city = null;
  },
  SET_CUSTOMER_PHONE: (state: IStateCustomer, payload: string): void => {
    state.phone = payload;
  },
  SET_USER_TAG: (state: IStateCustomer, payload: string): void => {
    state.userTag = payload;
  },
};
export default mutations;
